import { Box, Flex, HStack, Spacer } from '@chakra-ui/react';
import { UserDetail } from '@diamond/shared/types';
import { Avatar, Button, Checkbox, Divider, Text } from '@diamond/shared/ui';
import { useForm } from 'react-hook-form';

interface UserDetailProps {
  userDetail: UserDetail;
  isAdmin: boolean;
  onOpenEditUser: () => void;
  onOpenDeleteUser: () => void;
  hideButton: boolean;
}
export function UserDetailCardMobile({
  userDetail,
  isAdmin,
  onOpenEditUser,
  onOpenDeleteUser,
  hideButton,
}: UserDetailProps) {
  const method = useForm();

  return (
    <Box pb={4}>
      <Divider borderWidth="1px" mb="4" mt={-2} />
      <Flex w="full" rounded="lg" pb={2}>
        <Avatar
          size="md"
          name={`${userDetail?.first_name} ${userDetail?.last_name}`}
          src=""
        />
        <Box ml={4} mt={-1} w="full" alignSelf="center">
          <Text fontWeight="semibold" fontSize="lg">
            {`${userDetail?.first_name} ${userDetail?.last_name}`}
          </Text>
          <Text color="blue" as="u">
            {userDetail?.email}
          </Text>
        </Box>
      </Flex>
      <Divider borderWidth="1px" my="2" />
      <Box px={1} mt={4}>
        <Text fontWeight="medium" mb={1}>
          Email
        </Text>
        <Text>{userDetail?.email}</Text>
      </Box>
      <Flex px={1} mt={4} w="full" alignContent="space-between">
        <Box w="full">
          <Text fontWeight="medium" mb={1}>
            Nama Depan
          </Text>
          <Text>{userDetail?.first_name}</Text>
        </Box>
        <Box w="full">
          <Text fontWeight="medium" mb={1}>
            Nama Belakang
          </Text>
          <Text>{userDetail?.last_name}</Text>
        </Box>
      </Flex>
      <Box px={1} mt={4}>
        <Text fontWeight="medium" mb={1}>
          Nomor Bill To
        </Text>
        <Text>{userDetail?.bil_to_number || '-'}</Text>
      </Box>
      <Box px={1} mt={4}>
        <Text fontWeight="medium" mb={1}>
          Nama Perusahaan
        </Text>
        <Text>{userDetail?.company_name || '-'}</Text>
      </Box>

      <Box px={1} mt={4} h="300px" overflowY="auto">
        <Text mb={2}>Ship to</Text>
        {userDetail?.shiptos.map((val) => (
          <Checkbox
            key={val.id}
            name="shipto"
            isDisabled
            isChecked={val.is_selected}
            register={method.register}
            alignItems="start"
          >
            <Text mt="-0.1rem">{val.name}</Text>
          </Checkbox>
        ))}
      </Box>

      {!isAdmin && !hideButton && (
        <>
          <Divider borderWidth="1px" mb="4" mt={6} />
          <Box px={1} mt={4}>
            <HStack w="full" alignContent="space-between">
              <Button onClick={onOpenEditUser} w="full">
                Ubah Shipto
              </Button>
              {userDetail && userDetail?.request_admin_status !== 'waiting' && (
                <Button
                  w="full"
                  variant="solid"
                  bgColor="red"
                  onClick={onOpenDeleteUser}
                >
                  Remove User
                </Button>
              )}
            </HStack>
          </Box>
        </>
      )}
    </Box>
  );
}
